import client from "@irati/utils/services/apollo";
import productPermissionsForTenantQuery from "./queries/ProductPermissionsForTenant";
import productPermissionsForTeamQuery from "./queries/ProductPermissionsForTeam";
import updatePermissionsQuery from "./queries/updatePermissions";
var SwitchBoardService = /** @class */ (function () {
    function SwitchBoardService() {
        this.update = function (_a) {
            var tenantId = _a.tenantId, action = _a.action, teamId = _a.teamId, values = _a.values, option = _a.option;
            var variables = {
                tenantId: tenantId,
                data: {
                    action: action,
                    teamId: teamId,
                    values: values,
                    option: option
                }
            };
            // This should be a mutation so have to force network-only. We are re-writing to drop switchboard so not going to bother to change.
            return client.query({ query: updatePermissionsQuery, variables: variables, fetchPolicy: "network-only" });
        };
        this.get = function (tenant, product, fetchPolicy) {
            if (fetchPolicy === void 0) { fetchPolicy = "network-only"; }
            var variables = {
                tenantId: tenant.uuid
            };
            return client
                .query({ query: productPermissionsForTenantQuery, variables: variables, fetchPolicy: fetchPolicy })
                .then(function (_a) {
                var data = _a.data;
                return data.permissionsForTenant[product];
            });
        };
        this.getForTeam = function (tenant, team, product, fetchPolicy) {
            if (fetchPolicy === void 0) { fetchPolicy = "network-only"; }
            var variables = {
                tenantId: tenant.uuid,
                teamId: team.uuid
            };
            return client
                .query({ query: productPermissionsForTeamQuery, variables: variables, fetchPolicy: fetchPolicy })
                .then(function (_a) {
                var data = _a.data;
                return data.permissionsForTeam.permissions[product];
            });
        };
    }
    return SwitchBoardService;
}());
var service = new SwitchBoardService();
export var updatePermissions = service.update;
export var getPermissions = service.get;
export var getPermissionsForTeam = service.getForTeam;
export default service;
